import { render } from "./IosAndroid.vue?vue&type=template&id=9d0fa2be&scoped=true"
import script from "./IosAndroid.vue?vue&type=script&lang=js"
export * from "./IosAndroid.vue?vue&type=script&lang=js"

import "./IosAndroid.vue?vue&type=style&index=0&id=9d0fa2be&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d0fa2be"]])

export default __exports__